"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5866],{

/***/ 1412:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11752);




var ref = (0,next_config__WEBPACK_IMPORTED_MODULE_3__["default"])(), _publicRuntimeConfig = ref.publicRuntimeConfig, websiteName = _publicRuntimeConfig.settings.websiteName;
var isBricoStore = websiteName === "bricostore";
var ProductButtonViewResealed = function(param) {
    var href = param.href, _isCatalog = param.isCatalog, isCatalog = _isCatalog === void 0 ? false : _isCatalog;
    var buttonClasses = classnames__WEBPACK_IMPORTED_MODULE_1___default()("bg-[#39ab4a] hover:bg-[#2d883a] active:bg-[#3cb94ee4] block w-full text-white font-medium text-center", {
        "py-[7px] text-sm leading-18.2": isCatalog,
        "lg:w-1/2 p-3 leading-20.8": !isCatalog,
        // Brico: pill shape (like the other brico buttons); altex/MG keep the diagonal corners
        "rounded-full": isBricoStore,
        "rounded-tr-md rounded-bl-md": !isBricoStore && isCatalog,
        "rounded-tr-lg rounded-bl-lg": !isBricoStore && !isCatalog
    });
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_2__["default"], {
        href: href,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
            className: buttonClasses,
            children: "Vezi resigilate"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (ProductButtonViewResealed);


/***/ }),

/***/ 52372:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var _components_Tooltip__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(16729);
/* harmony import */ var _lib_helpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(15722);




var ProductListColorVariations = function(param) {
    var product = param.product;
    var ref;
    var sku = product.sku, configurable_options = product.configurable_options;
    var colorVariations = configurable_options.find(function(option) {
        return option.attribute_code === "culoare_global";
    });
    if (!colorVariations) {
        return null;
    }
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
        className: "inline-flex gap-[4px]",
        children: colorVariations === null || colorVariations === void 0 ? void 0 : (ref = colorVariations.values) === null || ref === void 0 ? void 0 : ref.map(function(option) {
            if (sku == option.sku) {
                return null;
            }
            var swatch = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_1__["default"], {
                href: "/".concat(option.url_key, "/cpd/").concat(option.sku, "/"),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: (0,_lib_helpers__WEBPACK_IMPORTED_MODULE_3__/* .resizeImage */ .tg)(option.image, "40x40"),
                        alt: option.label,
                        className: "w-[40px] h-[40px]"
                    })
                })
            });
            return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                className: "border border-[#C7C7C7] rounded p-[4px] w-[50px] h-[50px]",
                children: option.label ? // The swatches sit in a scrolling row, which would clip an
                // absolutely positioned tooltip
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Tooltip__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    content: option.label,
                    strategy: "fixed",
                    children: function() {
                        return swatch;
                    }
                }) : swatch
            }, option.id));
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (ProductListColorVariations);


/***/ }),

/***/ 38403:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11752);
/* harmony import */ var _lib_helpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(15722);




var ref = (0,next_config__WEBPACK_IMPORTED_MODULE_2__["default"])(), _publicRuntimeConfig = ref.publicRuntimeConfig, websiteName = _publicRuntimeConfig.settings.websiteName;
var isBricoStore = websiteName === "bricostore";
var Image = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.memo(function Image(param) {
    var src = param.src, className = param.className, name = param.name;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
        src: src,
        className: className,
        alt: name
    }));
});
var ProductListImage = function(param) {
    var thumbnail = param.thumbnail, name = param.name;
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Image, {
        src: (0,_lib_helpers__WEBPACK_IMPORTED_MODULE_3__/* .resizeImage */ .tg)(thumbnail, "300x300"),
        alt: "",
        name: name,
        className: isBricoStore ? "rounded-t-[8px]" : undefined
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ProductListImage);


/***/ }),

/***/ 11427:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11752);
/* harmony import */ var _components_Price__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(40641);
/* harmony import */ var _components_Ratings__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(57983);
/* harmony import */ var _components_ProductCardLabel__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(34532);
/* harmony import */ var _components_ProductList_ProductListImage__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(38403);
/* harmony import */ var _components_ProductList_ProductListTitle__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(95732);
/* harmony import */ var _containers_Catalog_Actions_AddToCompare__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(23915);
/* harmony import */ var _containers_Catalog_Actions_AddToWishlist__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(9614);
/* harmony import */ var _lib_helpers__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(15722);
/* harmony import */ var _components_ProductButtonViewResealed__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(1412);
/* harmony import */ var _components_ProductList_ProductListColorVariations__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(52372);














var ref = (0,next_config__WEBPACK_IMPORTED_MODULE_3__["default"])(), _publicRuntimeConfig = ref.publicRuntimeConfig, websiteName = _publicRuntimeConfig.settings.websiteName;
var isBricoStore = websiteName === "bricostore";
// Brico: offer label top-left; favorite/compare top-RIGHT and HIGH — identical to the
// category card (ProductListItem.js). The label's right edge (right-[52px]) stops before the
// ~32px buttons so it never runs under them.
var cornerLabelPos = isBricoStore ? "top-10px left-11px right-[52px] lg:top-15px lg:left-16px items-start" : "top-0 right-0 items-end";
var actionsPos = isBricoStore ? "top-10px right-11px lg:top-15px lg:right-16px" : "top-10px left-11px lg:top-15px lg:left-16px";
// Brico: don't clip the offer label's point/eyelet + small gap between labels; width is
// bounded by the left/right positions above (max-w-[85%] stays as a safety cap)
var cornerLabelBox = isBricoStore ? "overflow-visible gap-1 max-w-[85%]" : "truncate max-w-[75%]";
var ProductListResealedItem = function(param1) {
    var product = param1.product, deleteFromWishlist = param1.deleteFromWishlist, listType = param1.listType, onProductClick = param1.onProductClick, hasColorVariationsInCurrentRow = param1.hasColorVariationsInCurrentRow;
    var url_key = product.url_key, sku = product.sku, thumbnail = product.thumbnail, name = product.name, regular_price = product.regular_price, lowest_price = product.lowest_price, msrp_price = product.msrp_price, price = product.price, discount_type = product.discount_type, reviews_count = product.reviews_count, reviews_value = product.reviews_value, configurable_options = product.configurable_options;
    var hasColorVariations = (configurable_options === null || configurable_options === void 0 ? void 0 : configurable_options.length) && configurable_options.find(function(opt) {
        return opt.attribute_code === "culoare_global";
    });
    var ref1 = (0,_lib_helpers__WEBPACK_IMPORTED_MODULE_11__/* .productHelper */ .gU)(product), isDisabled = ref1.isDisabled, getLabels = ref1.getLabels, hasPricePerFactor = ref1.hasPricePerFactor, hasPriceUnit = ref1.hasPriceUnit;
    var onRemoveFromWishlist = function(event) {
        event.preventDefault();
        deleteFromWishlist(product);
    };
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("Products-item w-1/2 sm:w-1/3 p-1 sm:p-2 min-h-330px lg:min-h-400px bg-white", {
            "md:w-1/3": listType === "wishlist",
            "lg:w-1/4": listType !== "wishlist",
            "border-transparent md:border-2": websiteName !== "bricostore"
        }),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("Product flex flex-col relative", {
                "hover:shadow-mixRedYellow": websiteName !== "bricostore",
                "shadow-raised sm:hover:shadow-raised-hover border-0 rounded-[8px]": websiteName === "bricostore"
            }),
            onClick: function() {
                return onProductClick(product);
            },
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_1__["default"], {
                    href: "/".concat(url_key, "/cpd/").concat(sku, "/#resigilate"),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        title: "",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ProductList_ProductListImage__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                            thumbnail: thumbnail,
                            name: name
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_1__["default"], {
                    href: "/".concat(url_key, "/cpd/").concat(sku, "/#resigilate"),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        title: "",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ProductList_ProductListTitle__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            name: name
                        })
                    })
                }),
                !isDisabled && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        getLabels().length !== 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "absolute ".concat(cornerLabelPos, " h-auto w-auto flex flex-col ").concat(cornerLabelBox),
                            children: (isBricoStore ? getLabels().filter(function(label) {
                                return label.title;
                            }) : getLabels()).map(function(param, index) {
                                var title = param.title, variant = param.variant;
                                /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ProductCardLabel__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                    variant: variant,
                                    className: "truncate max-w-full",
                                    children: title
                                }, "".concat(title, "-").concat(index));
                            })
                        }),
                        hasColorVariationsInCurrentRow && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "mt-[8px] h-[56px] overflow-auto scrollbar-none",
                            children: hasColorVariations && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ProductList_ProductListColorVariations__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                product: product
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "leading-tight text-13px text-[#39AB4A] -tracking-0.27 h-18px font-semibold",
                            children: "resigilat"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "h-[20px] my-[4px]",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Ratings__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                reviewsCount: reviews_count,
                                ratingSummary: reviews_value,
                                displayReviewsNo: true,
                                productUrl: "/".concat(url_key, "/cpd/").concat(sku, "/")
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "mb-0 mt-auto",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Price__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                price: price,
                                regularPrice: regular_price,
                                lowestPrice: lowest_price,
                                msrp: msrp_price,
                                formatted: true,
                                discountType: discount_type,
                                displayDiscount: true,
                                size: "smaller",
                                resealedFilter: true,
                                displayUnit: hasPricePerFactor && hasPriceUnit ? product.price_unit.split("/")[1] : false
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "mt-14px sm:mt-13px",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ProductButtonViewResealed__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                href: "/".concat(url_key, "/cpd/").concat(sku, "/#resigilate"),
                                isCatalog: true
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "absolute ".concat(actionsPos, " flex flex-col justify-center items-center space-y-1.5"),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_containers_Catalog_Actions_AddToWishlist__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                            product: product
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_containers_Catalog_Actions_AddToCompare__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                            product: product
                        })
                    ]
                }),
                listType === "wishlist" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                    className: "mt-3 text-red-brand hover:text-bleu-hover underline text-sm outline-none",
                    onClick: onRemoveFromWishlist,
                    children: "Sterge"
                })
            ]
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (ProductListResealedItem);


/***/ }),

/***/ 95732:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var ProductListTitle = function(param) {
    var name = param.name;
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        className: "Product-name Heading leading-20 text-sm min-h-[68px] line-clamp-3 max-h-[68px]",
        children: name
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ProductListTitle);


/***/ }),

/***/ 74196:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ProductList_ProductListVariations; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/Icons/ProductCardSizeIcon.js

var ProductCardSizeIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? 16 : _width, _height = param.height, height = _height === void 0 ? 16 : _height;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0ZM10.75 4H8V5.25H10.75V8H12V5.25V4H10.75ZM5.25 8H4V10.75V12H5.25H8V10.75H5.25V8Z",
            fill: "#FE792F"
        })
    });
};
/* harmony default export */ var Icons_ProductCardSizeIcon = (ProductCardSizeIcon);

;// CONCATENATED MODULE: ./components/ProductList/ProductListVariations.js


var ProductListVariations = function(param) {
    var variations = param.variations;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_ProductCardSizeIcon, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "text-sm text-[#8B8C92] ml-2 leading-5",
                children: [
                    variations.size,
                    " ",
                    variations.label || "variante"
                ]
            })
        ]
    });
};
/* harmony default export */ var ProductList_ProductListVariations = (ProductListVariations);


/***/ }),

/***/ 75866:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_ProductList; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./lib/helpers.js
var helpers = __webpack_require__(15722);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(11752);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./components/Price/index.js + 1 modules
var Price = __webpack_require__(40641);
// EXTERNAL MODULE: ./components/Status.js
var Status = __webpack_require__(66552);
// EXTERNAL MODULE: ./containers/Catalog/Actions/AddToCart.js + 6 modules
var AddToCart = __webpack_require__(38973);
// EXTERNAL MODULE: ./components/Ratings/index.js + 1 modules
var Ratings = __webpack_require__(57983);
// EXTERNAL MODULE: ./components/ProductCardLabel.js
var ProductCardLabel = __webpack_require__(34532);
// EXTERNAL MODULE: ./components/ProductList/ProductListImage.js
var ProductListImage = __webpack_require__(38403);
// EXTERNAL MODULE: ./components/ProductList/ProductListTitle.js
var ProductListTitle = __webpack_require__(95732);
;// CONCATENATED MODULE: ./components/ProductList/ProductListConfigureButton.js



var ref = (0,config["default"])(), _publicRuntimeConfig = ref.publicRuntimeConfig, websiteName = _publicRuntimeConfig.settings.websiteName;
var isBricoStore = websiteName === "bricostore";
var ProductListConfigureButton = function(param) {
    var _disabled = param.disabled, disabled = _disabled === void 0 ? false : _disabled;
    var classes = classnames_default()("mt-14px sm:mt-13px py-7px leading-18.2 text-center outline-none text-sm font-medium text-white active:opacity-75 group w-full sm:hover:bg-red-hover sm:focus:bg-red-active", {
        // altex/MG unchanged; bricostore → pill + guideline red scale
        "rounded-tr-md rounded-bl-md bg-red-lightdark": !isBricoStore,
        "rounded-full": isBricoStore,
        "bg-red-brand": isBricoStore && !disabled,
        "bg-red-off": isBricoStore && disabled,
        "opacity-25": disabled && !isBricoStore,
        "cursor-not-allowed": disabled
    });
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
        className: classes,
        disabled: disabled,
        children: "Configureaza"
    }));
};
/* harmony default export */ var ProductList_ProductListConfigureButton = (ProductListConfigureButton);

// EXTERNAL MODULE: ./containers/Catalog/Actions/AddToCompare.js
var AddToCompare = __webpack_require__(23915);
// EXTERNAL MODULE: ./containers/Catalog/Actions/AddToWishlist.js + 1 modules
var AddToWishlist = __webpack_require__(9614);
// EXTERNAL MODULE: ./components/ProductList/ProductListVariations.js + 1 modules
var ProductListVariations = __webpack_require__(74196);
// EXTERNAL MODULE: ./components/Button.js
var Button = __webpack_require__(52077);
// EXTERNAL MODULE: ./components/ProductFinancing/index.js + 7 modules
var ProductFinancing = __webpack_require__(73363);
// EXTERNAL MODULE: ./components/ProductList/ProductListColorVariations.js
var ProductListColorVariations = __webpack_require__(52372);
;// CONCATENATED MODULE: ./components/ProductList/ProductListItem.js



















var ProductListItem_ref = (0,config["default"])(), ProductListItem_publicRuntimeConfig = ProductListItem_ref.publicRuntimeConfig, settings = ProductListItem_publicRuntimeConfig.settings, credex = ProductListItem_publicRuntimeConfig.credex, oney = ProductListItem_publicRuntimeConfig.oney;
var ProductListItem_isBricoStore = settings.websiteName === "bricostore";
// Brico: offer label top-left; favorite/compare top-RIGHT and HIGH (George). The label's
// right edge (right-[52px]) stops before the ~32px buttons so it never runs under them.
var cornerLabelPos = ProductListItem_isBricoStore ? "top-10px left-11px right-[52px] lg:top-15px lg:left-16px items-start" : "top-0 right-0 items-end";
var actionsPos = ProductListItem_isBricoStore ? "top-10px right-11px lg:top-15px lg:right-16px" : "top-10px left-11px lg:top-15px lg:left-16px";
// Brico: don't clip the offer label's point/eyelet (extend past the box) + small gap between
// labels; width is bounded by the left/right positions above so long text truncates before
// the buttons (max-w-[85%] stays as a safety cap, e.g. the wide Black-Friday listing badge)
var cornerLabelBox = ProductListItem_isBricoStore ? "overflow-visible gap-1 max-w-[85%]" : "truncate max-w-[75%]";
var ProductListItem = function(param1) {
    var listType = param1.listType, onProductClick = param1.onProductClick, product = param1.product, deleteFromWishlist = param1.deleteFromWishlist, hasColorVariationsInCurrentRow = param1.hasColorVariationsInCurrentRow;
    var url_key = product.url_key, sku = product.sku, thumbnail = product.thumbnail, name = product.name, regular_price = product.regular_price, lowest_price = product.lowest_price, msrp_price = product.msrp_price, price = product.price, discount_type = product.discount_type, reviews_value = product.reviews_value, reviews_count = product.reviews_count, variations_info = product.variations_info, configurable_options = product.configurable_options;
    var ref1 = (0,helpers/* productHelper */.gU)(product), isDisabled = ref1.isDisabled, isSaleable = ref1.isSaleable, isWestaco = ref1.isWestaco, hasStorePickup = ref1.hasStorePickup, isInSpecialCampaign = ref1.isInSpecialCampaign, hasPricePerFactor = ref1.hasPricePerFactor, hasPriceUnit = ref1.hasPriceUnit, isVirtualService = ref1.isVirtualService, isLocalSeller = ref1.isLocalSeller, getLabels = ref1.getLabels;
    var onRemoveFromWishlist = function(event) {
        event.preventDefault();
        deleteFromWishlist(product);
    };
    var hasColorVariations = (configurable_options === null || configurable_options === void 0 ? void 0 : configurable_options.length) && configurable_options.find(function(opt) {
        return opt.attribute_code === "culoare_global";
    });
    var hasVariationsInfo = (variations_info === null || variations_info === void 0 ? void 0 : variations_info.size) > 1;
    var hasFinancingOptions = Boolean(isLocalSeller && product.installments_price > 0 && (credex.isEnabled && !isVirtualService || oney.isEnabled));
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
        className: classnames_default()("w-1/2 sm:w-1/3 p-1 sm:p-2 min-h-330px lg:min-h-400px bg-white", {
            "md:w-1/3": listType === "wishlist",
            "lg:w-1/4": listType !== "wishlist",
            "border-transparent md:border-2": settings.websiteName !== "bricostore"
        }),
        onClick: function() {
            onProductClick(product, listType === "search" ? {
                source: "search_result"
            } : undefined);
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: classnames_default()("Product flex flex-col relative", {
                "hover:shadow-mixRedYellow": settings.websiteName !== "bricostore",
                "shadow-raised sm:hover:shadow-raised-hover border-0 rounded-[8px]": settings.websiteName === "bricostore"
            }),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                    href: "/".concat(url_key, "/cpd/").concat(sku, "/"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        title: "",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductListImage/* default */.Z, {
                            thumbnail: thumbnail,
                            name: name
                        })
                    })
                }),
                ProductListItem_isBricoStore && !isDisabled && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mt-[6px] mb-[2px]",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Status/* default */.Z, {
                        product: product
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                    href: "/".concat(url_key, "/cpd/").concat(sku, "/"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        title: "",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductListTitle/* default */.Z, {
                            name: name
                        })
                    })
                }),
                !isDisabled && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        getLabels().length >= 1 && isInSpecialCampaign && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "absolute ".concat(cornerLabelPos, " h-auto w-auto flex flex-col ").concat(cornerLabelBox),
                            children: getLabels().slice(0, 1).map(function(param, index) {
                                var title = param.title, variant = param.variant;
                                /*#__PURE__*/ return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCardLabel/* default */.Z, {
                                            variant: variant,
                                            className: "truncate max-w-full",
                                            children: title
                                        }, "".concat(title, "-").concat(index)),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "p-0.5",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "".concat(settings.websiteStatics, "/images/oferta-de-black-friday-listing.svg"),
                                                alt: "oferta de black friday"
                                            })
                                        })
                                    ]
                                });
                            })
                        }),
                        getLabels().length >= 1 && !isInSpecialCampaign && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "absolute ".concat(cornerLabelPos, " h-auto w-auto flex flex-col ").concat(cornerLabelBox),
                            children: (ProductListItem_isBricoStore ? getLabels().filter(function(label) {
                                return label.title;
                            }) : getLabels()).map(function(param, index) {
                                var title = param.title, variant = param.variant;
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)(ProductCardLabel/* default */.Z, {
                                    variant: variant,
                                    className: "truncate max-w-full",
                                    children: title
                                }, "".concat(title, "-").concat(index));
                            })
                        }),
                        getLabels().length === 0 && isInSpecialCampaign && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "absolute ".concat(cornerLabelPos, " h-auto w-auto flex flex-col ").concat(cornerLabelBox, " p-0.5"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "".concat(settings.websiteStatics, "/images/oferta-de-black-friday-listing.svg"),
                                alt: "oferta de black friday"
                            })
                        }),
                        hasColorVariationsInCurrentRow && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mt-[8px] h-[56px] overflow-auto scrollbar-none",
                            children: hasColorVariations && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductListColorVariations/* default */.Z, {
                                product: product
                            })
                        }),
                        hasVariationsInfo && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "h-[20px] my-[6px] flex items-center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductListVariations/* default */.Z, {
                                variations: variations_info
                            })
                        }),
                        !ProductListItem_isBricoStore && /*#__PURE__*/ (0,jsx_runtime.jsx)(Status/* default */.Z, {
                            product: product
                        }),
                        reviews_count > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "my-[4px]",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Ratings/* default */.Z, {
                                reviewsCount: reviews_count,
                                ratingSummary: reviews_value,
                                displayReviewsNo: true,
                                productUrl: "/".concat(url_key, "/cpd/").concat(sku, "/")
                            })
                        }),
                        hasFinancingOptions && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "py-[6px] cursor-pointer w-fit",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductFinancing/* default */.Z, {
                                product: product,
                                label: "productCard"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "mb-0 mt-auto",
                            children: [
                                isWestaco && price && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "leading-20 sm:leading-normal",
                                    children: "De la"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* default */.Z, {
                                    price: price,
                                    regularPrice: regular_price,
                                    lowestPrice: lowest_price,
                                    msrp: msrp_price,
                                    formatted: true,
                                    discountType: discount_type,
                                    displayDiscount: true,
                                    size: "smaller",
                                    displayUnit: hasPricePerFactor && hasPriceUnit ? product.price_unit.split("/")[1] : false
                                })
                            ]
                        }),
                        hasVariationsInfo && isSaleable && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mt-14px sm:mt-13px",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                title: "Selecteaza varianta",
                                href: "/".concat(url_key, "/cpd/").concat(sku, "/"),
                                variant: "primary",
                                display: "block",
                                isCatalog: true
                            })
                        }),
                        isWestaco && /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                            href: "/".concat(url_key, "/cpd/").concat(sku, "/"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                title: "",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductList_ProductListConfigureButton, {})
                            })
                        }),
                        (isSaleable || hasStorePickup) && !hasVariationsInfo && !isWestaco && /*#__PURE__*/ (0,jsx_runtime.jsx)(AddToCart/* default */.Z, {
                            titleOnlyOnMobile: settings.websiteName === "bricostore",
                            product: product,
                            isCatalog: true,
                            noMargin: true
                        })
                    ]
                }),
                listType === "wishlist" && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    className: "mt-3 text-red-brand hover:text-bleu-hover underline text-sm outline-none",
                    onClick: onRemoveFromWishlist,
                    children: "Sterge"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "absolute ".concat(actionsPos, " flex flex-col justify-center items-center space-y-1.5"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AddToWishlist/* default */.Z, {
                            product: product
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AddToCompare/* default */.Z, {
                            product: product
                        })
                    ]
                })
            ]
        })
    }));
};
/* harmony default export */ var ProductList_ProductListItem = (ProductListItem);

// EXTERNAL MODULE: ./components/ProductList/ProductListResealedItem.js
var ProductListResealedItem = __webpack_require__(11427);
;// CONCATENATED MODULE: ./components/ProductList/index.js






var getProductsPerRow = function(param) {
    var listType = param.listType, width = param.width;
    if (width < 640) return 2;
    if (listType === "wishlist") {
        return 3;
    }
    if (width < 1021) return 3;
    return 4;
};
var getProductsInCurrentRow = function(param) {
    var products = param.products, index = param.index, productsPerRow = param.productsPerRow;
    var currentRowStartIndex = Math.floor(index / productsPerRow) * productsPerRow;
    var currentRowEndIndex = currentRowStartIndex + productsPerRow - 1;
    return products.slice(currentRowStartIndex, currentRowEndIndex + 1);
};
var ProductList = function(param) {
    var products = param.products, containerClass = param.containerClass, filter = param.filter, listType = param.listType, onProductClick = param.onProductClick, deleteFromWishlist = param.deleteFromWishlist;
    var observerRef = (0,react.useRef)(null);
    var ref1 = (0,react.useState)(), width = ref1[0], setWidth = ref1[1];
    var isResealedSelected = !filter ? false : Object.keys(filter.filters).includes("resigilate-8691");
    (0,react.useEffect)(function() {
        observerRef.current = new ResizeObserver(function(entries) {
            setWidth(entries[0].contentRect.width);
        });
        observerRef.current.observe(document.querySelector("body"));
        return function() {
            observerRef.current.disconnect();
        };
    }, []);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
        className: "".concat(containerClass, " -mx-1 sm:-mx-2"),
        children: products.map(function(product, i) {
            var isSaleable = (0,helpers/* productHelper */.gU)(product).isSaleable;
            var productsPerRow = getProductsPerRow({
                listType: listType,
                width: width
            });
            var productsInCurrentRow = getProductsInCurrentRow({
                products: products,
                index: i,
                productsPerRow: productsPerRow
            });
            var hasColorVariationsInCurrentRow = productsInCurrentRow.some(function(p) {
                var ref;
                return ((ref = p.configurable_options) === null || ref === void 0 ? void 0 : ref.length) && p.configurable_options.find(function(option) {
                    return option.attribute_code === "culoare_global";
                });
            });
            var isStockZeroWithResealed = !isSaleable && product.resealed_count > 0 && product.pickup_is_in_stock < 1;
            if (isResealedSelected || isStockZeroWithResealed) {
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)(ProductListResealedItem/* default */.Z, {
                    listType: listType,
                    product: product,
                    deleteFromWishlist: deleteFromWishlist,
                    onProductClick: onProductClick,
                    hasColorVariationsInCurrentRow: hasColorVariationsInCurrentRow
                }, product.id + "-" + i));
            } else {
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)(ProductList_ProductListItem, {
                    index: i,
                    listType: listType,
                    product: product,
                    onProductClick: onProductClick,
                    deleteFromWishlist: deleteFromWishlist,
                    hasColorVariationsInCurrentRow: hasColorVariationsInCurrentRow
                }, product.id + "-" + i));
            }
        })
    }));
};
ProductList.propTypes = {
    onProductClick: (prop_types_default()).func.isRequired
};
/* harmony default export */ var components_ProductList = (ProductList);


/***/ })

}]);